import type { PurchaseLimits } from '@patrianna/shared-patrianna-types/store/ShopModule'
import type { OfferInfo } from '@patrianna-payments/shared-store/payments/types/openApiModels/OfferInfo'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { ShopState } from './types'

const initialState: ShopState = {
  offers: [],
  applied: [],
  lastPurchasedOffer: null,
  limits: null,
  isUserOffers: false,
  loaded: false,
  activeGameRoute: '',
  offersLastFetchedAt: 0,
}

export const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    setActivatedGame: (state, action: PayloadAction<{ activeGameRoute: string }>) => {
      state.activeGameRoute = action.payload.activeGameRoute
    },

    addOffersAction: (state, action: PayloadAction<{ offers: Array<OfferInfo> }>) => {
      state.offers = action.payload.offers
    },

    addAppliedOffers: (state, action: PayloadAction<{ appliedOffers: Array<OfferInfo> }>) => {
      state.applied = action.payload.appliedOffers
    },

    addLastPurchasedOffer: (state, action: PayloadAction<{ lastPurchasedOffer: OfferInfo }>) => {
      state.lastPurchasedOffer = action.payload.lastPurchasedOffer
    },

    setPurchaseLimits: (state, action: PayloadAction<{ limits: PurchaseLimits | null }>) => {
      state.limits = action.payload.limits
    },

    setIsUserOffers: (state, action: PayloadAction<{ isUserOffers: boolean }>) => {
      state.isUserOffers = action.payload.isUserOffers
    },

    setOffersLoaded: (state, action: PayloadAction<boolean>) => {
      state.loaded = action.payload
    },

    setOffersLastFetchedAt: (state, action: PayloadAction<number>) => {
      state.offersLastFetchedAt = action.payload
    },

    clearProducts: () => initialState,
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof shopSlice.actions>>
export const { actions } = shopSlice
